import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "../components/LoginPage.vue";
import ResetPassword from "../components/ResetPassword.vue";
import MainLayout from "../components/MainLayout.vue";
import DashBoard from "../views/DashBoard.vue";
// import DataTask from "../views/DataTask.vue";
import UserManagement from "@/views/UserManagement.vue";
import ReportEditor from "@/views/ReportEditor.vue";
import ReportTemplates from "@/views/ReportTemplates.vue";
import DataProject from "@/views/DataProject.vue";
import DataProjectEdit from "@/views/DataProjectEdit.vue";
import KnowledgeBase from "@/views/KnowledgeBase.vue";
import UserInit from "@/views/UserInit.vue"
import App from "../App.vue";

const routes = [
  {
    path: "/",
    redirect: "/login", // 默认重定向到登录页
  },
  {
    path: "/login",
    component: App,
    children: [
      {
        path: "",
        component: LoginPage,
      },
      {
        path: "inituser",
        component: UserInit,
      }
    ],
  },
  {
    path: "/reset-password",
    component: ResetPassword,
  },
  {
    path: "/main",
    component: MainLayout,
    children: [
      {
        path: "data-project",
        component: DataProject,
      },
      {
        path: "project-edit/:id?",
        name: "ProjectEdit",
        component: DataProjectEdit,
        props: true
      },
      {
        path: "dashboard",
        component: DashBoard,
      },
      // {
      //   path: "data-task",
      //   component: DataTask,
      // },
      {
        path: "report-editor/:id?",
        name: "ReportEditor",
        component: ReportEditor,
        props: true
      },
      {
        path: "report-templates",
        component: ReportTemplates,
      },
      {
        path: "user-management",
        component: UserManagement,
      },
      {
        path: "knowledge-base",
        component: KnowledgeBase,
      },
      {
        path: 'data-projects/detail/:project_id',
        name: 'DataProjectDetail',
        component: () => import('@/views/DataProjectDetail.vue'),
        meta: { title: '项目详情' }
      },
      {
        path: 'data-tasks',
        component: App,
        redirect: '/main/data-tasks/overview',
        name: 'DataTasks',
        meta: { title: '数据任务', icon: 'el-icon-s-order' },
        children: [
          {
            path: 'overview',
            name: 'DataTaskOverview',
            component: () => import('@/views/DataTaskOverview'),
            meta: { title: '项目概览' }
          },
          {
            path: 'analysis',
            name: 'DataTaskAnalysis',
            component: () => import('@/views/DataTaskAnalysis'),
            meta: { title: '数据分析' }
          },
          {
            path: 'public-health-analysis',
            name: 'PublicHealthCombinedAnalysis',
            component: () => import('@/views/PublicHealthCombinedAnalysis'),
            meta: { title: '公共卫生科数据分析' }
          },
          {
            path: 'cdc-analysis',
            name: 'CDCAnalysis',
            component: () => import('@/views/CDCAnalysis'),
            meta: { title: '疫情防控科数据分析' }
          },
          {
            path: 'screen',
            name: 'DataTaskDataScreen',
            component: () => import('@/views/DataTaskDataScreen.vue'),
            meta: { title: '数据大屏' }
          },
          {
            path: 'public-health-screen',
            name: 'PublicHealthDataScreen',
            component: () => import('@/views/PublicHealthDataScreen.vue'),
            meta: { title: '公共卫生科数字大屏' }
          },
          {
            path: 'cdc-screen',
            name: 'CDCDataScreen',
            component: () => import('@/views/CDCDataScreen.vue'),
            meta: { title: '疫情防控科数字大屏' }
          },
          {
            path: 'league-overview-screen',
            name: 'LeagueOverviewDataScreen',
            component: () => import('@/views/LeagueOverviewDataScreen.vue'),
            meta: { title: '盟中心数字大屏' }
          },
          {
            path: 'fill',
            name: 'DataTaskFill',
            component: () => import('@/views/DataTaskFill'),
            meta: { title: '填报任务' }
          },
          {
            path: 'county-approval',
            name: 'DataTaskCountyApproval',
            component: () => import('@/views/DataTaskCountyApproval'),
            meta: { title: '报表审批' }
          },
          {
            path: 'summary-approval',
            name: 'DataTaskSummaryApproval',
            component: () => import('@/views/DataTaskSummaryApproval'),
            meta: { title: '汇总审批' }
          },
          {
            path: 'form/:taskId',
            name: 'DataTaskForm',
            component: () => import('@/views/DataTaskForm.vue'),
            meta: { title: '数据填报' }
          },
          {
            path: 'edit/:taskId',
            name: 'DataTaskEdit',
            component: () => import('@/views/DataTaskForm.vue'),
            meta: { title: '编辑数据', isAdminEdit: true }
          },
          {
            path: 'approve/:taskId',
            name: 'DataTaskApprove',
            component: () => import('@/views/DataTaskApprove.vue'),
            meta: { title: '数据审批' }
          },
          {
            path: 'detail/:batchId',
            name: 'DataTaskDetail',
            component: () => import('@/views/DataTaskDetail.vue'),
            meta: { title: '任务详情' }
          },
          {
            path: 'batch-approve/:batchId',
            name: 'DataTaskBatchApprove',
            component: () => import('@/views/DataTaskBatchApprove.vue'),
            meta: { requiresAuth: true }
          },
          {
            path: 'report-config',
            name: 'ReportConfigManagement',
            component: () => import('@/views/ReportConfigManagement.vue'),
            meta: { title: '报表配置管理', requiresCenterAdmin: true }
          }
        ]
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const userInfo = localStorage.getItem("userInfo");
  let user = null;
  if (userInfo) {
    try {
      user = JSON.parse(userInfo);
    } catch (error) {
      console.error("用户信息解析失败:", error);
    }
  }

  // 判断是否是登录相关页面
  const isLoginPage = to.path.startsWith('/login');
  const isResetPasswordPage = to.path === '/reset-password';
  const isPublicPage = isLoginPage || isResetPasswordPage;
  
  // 已登录但访问登录相关页面，跳转到overview
  if (userInfo && isPublicPage) {
    next('/main/data-tasks/overview');
    return;
  }
  
  // 未登录且访问非公开页面，跳转到登录页
  if (!userInfo && !isPublicPage) {
    console.log('未登录且访问非公开页面，跳转到登录页');
    next('/login');
    return;
  }

  const isRestrictedDataPage =
    to.path.startsWith('/main/data-tasks/analysis') ||
    to.path.startsWith('/main/data-tasks/public-health-analysis') ||
    to.path.startsWith('/main/data-tasks/cdc-analysis') ||
    to.path.startsWith('/main/data-tasks/screen') ||
    to.path.startsWith('/main/data-tasks/public-health-screen');
  const canViewRestrictedData =
    user &&
    (user.user_type === 1 ||
      (user.user_type === 2 &&
        (user.user_dept_type === 2 || user.user_dept_type === 1)));

  if (isRestrictedDataPage && !canViewRestrictedData) {
    next('/main/data-tasks/overview');
    return;
  }

  // 中心知识库：只有盟中心（user_dept_type===2）或超管（user_type===1）能进
  if (
    to.path.startsWith('/main/knowledge-base') &&
    !(user && (user.user_type === 1 || user.user_dept_type === 2))
  ) {
    next('/main/data-tasks/overview');
    return;
  }

  // 其他情况正常放行
  next();
});

export default router;
